<template>
  <task-list-view type="myApply" />
</template>

<script>
import TaskListView from './components/TaskListView.vue'

export default {
  name: 'WflowMyApply',
  components: { TaskListView }
}
</script>
